{
  "version": 1,
  "asset_id": "8b7c689e-221e-4e4d-9aae-5098a8af55c7",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8b7c689e-221e-4e4d-9aae-5098a8af55c7/dr-fitzer-home-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8b7c689e-221e-4e4d-9aae-5098a8af55c7/dr-fitzer-home-480.webp",
  "original_filename": "dr-fitzer-home-480.webp",
  "size": 22556,
  "content_type": "image/webp",
  "created_at": "2026-07-21T12:07:40Z"
}
